export default __webpack_public_path__ + "static/media/slide3.363c9d3f.jpg";